import * as React from 'react'
import { FC, ReactNode, useState } from 'react'
import { Link, Notification } from 'is24-corecss'
import { Trans, useTranslation } from 'react-i18next'
import { Styles, TooltipTypes } from '../../../../@types/types'
import { TooltipModal } from '../tooltipModal/TooltipModal'
import 'pure-react-carousel/dist/react-carousel.es.css'
import { useTooltipNameSpace } from '../../../../utils/tooltipHooks'
import styles from './ScreenTooltip.module.css'

export interface ScreenTooltipProps {
  tooltipType: TooltipTypes
  tooltipKey: string
  desktopFooter?: ReactNode
}

const customStyles: Styles = {
  statusHeader: {
    hyphens: 'auto',
  },
  opacity: {
    mixBlendMode: 'normal',
    opacity: 0.6,
    wordBreak: 'break-word',
  },
}

export const ScreenTooltip: FC<ScreenTooltipProps> = ({
  tooltipType,
  tooltipKey,
  desktopFooter,
}: ScreenTooltipProps) => {
  const namespace = useTooltipNameSpace()

  const { t, i18n } = useTranslation(namespace)
  const [isModalOpen, setModalOpen] = useState(false)
  const showModalLink: boolean = i18n.exists(`${tooltipKey}.title`, { ns: namespace })
  const hasCustomTitle: boolean = i18n.exists(`${tooltipKey}.title`, { ns: namespace })
  const closeModal = () => {
    document.body.classList.remove('modal-open')
    setModalOpen(false)
  }

  const openModal = () => {
    document.body.classList.add('modal-open')
    setModalOpen(true)
  }

  const getHeadline = () => {
    if (hasCustomTitle) {
      return t(`${tooltipKey}.title`)
    }
    return showModalLink ? t('tooltip.headlines.tips') : t('tooltip.headlines.tip')
  }

  return (
    <>
      {(tooltipType === TooltipTypes.DESKTOP || tooltipType === TooltipTypes.LEVITATING) && (
        <div className={`${styles.statusMessage} padding-m border-left palm-hide lap-hide`}>
          <div className='font-body-small-bold' style={customStyles.statusHeader}>
            <span className='is24-icon-offer margin-right-xs' />
            {getHeadline()}
          </div>
          <div className='margin-top font-body-small-regular' style={customStyles.opacity}>
            <Trans ns={namespace} i18nKey={`${tooltipKey}.hint`} />
            {showModalLink && (
              <a className='screen-tooltip-open-modal' onClick={openModal}>
                <Trans ns={namespace} i18nKey={'tooltip.screens.readMore'} />
              </a>
            )}
          </div>
          {desktopFooter}
        </div>
      )}
      {tooltipType === TooltipTypes.MOBILE && (
        <Notification
          title={getHeadline()}
          message={t(`${tooltipKey}.hint`)}
          actionButton={showModalLink ? <Link onClick={openModal}>{t('tooltip.screens.readMore')}</Link> : undefined}
          className={'status-message desk-hide margin-top-l'}
          type={'info'}
          variant={'flat'}
        />
      )}
      <TooltipModal isOpen={isModalOpen} tooltipKey={tooltipKey} namespace={namespace} onClose={closeModal} />
    </>
  )
}
